

/**
 * This composition function exposes functions for determining the list of plans and the current plan based upon the
 * user's profile and the state in context.  It can be used on both the server and the client (browser) as it uses
 * the profile and context which are both stored in the model and available on the server and client.
 */
 export default function usePlan(prof, ctx) {

  const profile = prof?.value ? prof.value : prof
  const context = ctx?.value ? ctx.value : ctx


  /**
 * Returns true if the authenticated user is a dental only member.
 */
const isDentalOnly = () => {
  return profile.dentalPlans?.length > 0 && profile.medicalPlans?.length === 0
}

/**
 * Returns true if the authenticated user is a medical only member.
 */
const isMedicalOnly = () => {
  return profile.medicalPlans?.length > 0 && profile.dentalPlans?.length === 0
}

const getMedicalPlans = () => {
  return profile.medicalPlans ? profile.medicalPlans : []
}

const getDentalPlans = () => {
  return profile.dentalPlans ? profile.dentalPlans : []
}

const getSimplicaPlans = () => {
  return profile.simplicaMedicalPlans ? profile.simplicaMedicalPlans : []
}

const getPlans = () => {
  return context.type == 'dental' || context.type == 'dentist' || isDentalOnly() ? profile.dentalPlans : profile.medicalPlans
}

const getPlan = () => determinePlan()

/**
 * Determine the current plan based upon the user's profile and the state of the context.
 */
const determinePlan = () => {
  if(profile) {
    const plans = getPlans()

    if (context.networkIndex) {
      return plans[context.networkIndex]
    }

    return plans && plans.length > 0 ? plans[0] : null
  }
  return null
}

/**
 * Return the group number from plan information.
 */
const getGroupNumber = () => {
  const plan = getPlan()
  return plan && plan.coverageInfo ? plan.coverageInfo.groupNumber : ''
}

/**
 * Determine the networkId to be used in the request to service-locator for practitioner details.
 */
const getNetworkId = () => {
  //if ( ctx.networkId ) return ctx.networkId
  const plan = getPlan()
  return plan && plan.networkId ? plan.networkId : ''
}

return { getNetworkId, getPlan, getPlans, getGroupNumber, 
  isDentalOnly, isMedicalOnly, getMedicalPlans, getDentalPlans, getSimplicaPlans }

}
  